<template>
  <a-select  v-model:value="selectId" :style="{width:'200px'}" placeholder="请选择" @change="changeFreight">
    <a-select-option v-for='(item,index) in freightList' :key="index" :value="item.id" >{{item.name}}</a-select-option>
  </a-select>
</template>


<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { getDeliveryList } from "@/api/order";
import { iscode } from "../../utils/app";
import { message } from "ant-design-vue";
import store from '@/store'
export default {
  name:"selectFreight",
  props:{
    id:Number
  },
  setup(props, { emit }) {
    const selectId=ref('')
    const state = reactive({
      freightList: [],
    });
    // 获取运费模板
    const getFreight = async () => {
      let res = await getDeliveryList({ page: 1, limit: 99 }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.freightList = res.data.data;
        if(!props.id){
         emit("update:value", res.data.data[0].id);
        }
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      getFreight();
      selectId.value=props.id
    });
    const changeFreight = (e) => {
      emit("update:value", e);
    };
    return {
      changeFreight,
      selectId,
      ...toRefs(state)
    };
  },
};
</script>